/**
 * MerlinCallWidget — bottom-right floating "Talk to Merlin" FAB. A plain
 * router link to /intake, the full-bleed Merlin embed page and the single
 * front door for every intake flow on the site. There is no modal — the
 * /intake page IS the intake surface (iframe to merlin.artificersai.com/intake).
 */
import { Link } from '@tanstack/react-router';
import merlinAvatar from '../../../assets/merlin/merlin-avatar.png';

export default function MerlinCallWidget() {
  return (
    <Link to="/intake" className="merlin-fab" aria-label="Talk to Merlin">
      <span className="merlin-fab-avatar-frame" aria-hidden="true">
        <img className="merlin-fab-avatar" src={merlinAvatar} alt="" loading="eager" decoding="async" />
      </span>
      <span className="merlin-fab-label">
        <span className="merlin-fab-label-top">Talk to Merlin</span>
        <span className="merlin-fab-label-sub">Guided intake</span>
      </span>
    </Link>
  );
}
